<template>
  <div class="card">
    <h6>Web interface</h6>
    <div style="display: flex; flex-direction: column">
      <div>
        Link to
        <a href="http://10.40.41.63:8080/rest/swagger-ui.html" target="_blank"
          >HTTP</a
        >
      </div>
      <div>
        Link to
        <a href="https://10.40.41.63:8080/rest/swagger-ui.html" target="_blank"
          >HTTPS</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "server-front-web-interface",
  data() {
    return {};
  },
};
</script>
